import React, { useState } from "react";
import { formStyles } from "styles/form";
import { StyleSheet, View } from "react-native";
import Text from 'theme/Text';
import HelperString from "utils/helper-string";

const FormRow = ({ title, hint, warning, children }) => {
	
	const [ width, setWidth ] = useState( '100%' )

	return (
		<View
			style={ staticStyles.viewMinWidth100Width100 }
			onLayout={ e => {
				const _rowWidth = e.nativeEvent.layout.width;
				
				if( _rowWidth !== width ) {
					setWidth( _rowWidth )
				}
			}}>
			
			<View
				style={ formStyles.rowContainer }>
				
				{ !HelperString.isEmptyString( title ) && (
					<View style={ formStyles.row }>
						<Text
							appearance={ "default" }
							category={ 'label' }
							style={ formStyles.title }>
							
							{ title }
						</Text>
					</View>
				)}
				
				{ warning && (
					<View style={ formStyles.row }>
						<Text
							appearance={ "default" }
							category={ 'label' }
							style={ formStyles.warning }>
							
							{ warning }
						</Text>
					</View>
				)}
				
				<View style={ formStyles.row }>
					{ children }
				</View>
				
				{ hint && (
					<View style={ formStyles.row }>
						<Text
							appearance={ "hint" }
							category={ 'p' }
							style={ formStyles.hint }>
							
							{ hint }
						</Text>
					</View>
				)}
			</View>
		</View>
	)
}

const staticStyles = StyleSheet.create({
	viewMinWidth100Width100: {
		minWidth: '100%',
		width: '100%',
	},
});

export default FormRow
